module.exports = __webpack_public_path__ + "90f6ff02.woff";